// PRODUCTION — retroactive collect row under optional flag
import React, { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { ConfigRow } from './layout'
import { SoloCheckbox } from './SoloCheckbox'

export const RETRO_COLLECT_ROW_LABEL = 'Recollect step for existing contractors'

export function RetroactiveCollectUnderOptionalFormik<T extends { optional: boolean }>({
  readOnly,
  checked,
  onChange,
}: {
  readOnly: boolean
  checked: boolean
  onChange: (v: boolean) => void
}) {
  const { values } = useFormikContext<T>()
  const optional = values.optional
  const retroactiveDisabled = readOnly || !optional

  useEffect(() => {
    if (!optional && checked) {
      onChange(false)
    }
  }, [optional, checked, onChange])

  return (
    <ConfigRow label={RETRO_COLLECT_ROW_LABEL} disabled={retroactiveDisabled}>
      <SoloCheckbox checked={checked} onChange={onChange} disabled={retroactiveDisabled} />
    </ConfigRow>
  )
}
